import React from "react";
import { array, bool, string, func, object } from "prop-types";
import { MemberDirectory } from "../../../molecules/member-directory";

export const MemberDirectoryTab = ({
  filteredMembers,
  membersLoading,
  membersError,
  selectedRegions,
  availableRegions,
  primaryRole,
  onSearchChange,
  onRegionFilterChange,
  onRetry,
  onRemoveRegionFilter,
  onClearAllFilters
}) => {
  return (
    <MemberDirectory
      members={filteredMembers}
      primaryRole={primaryRole}
      onSearch={onSearchChange}
      isLoading={membersLoading}
      error={membersError}
      onRetry={onRetry}
      availableRegions={availableRegions}
      selectedRegions={selectedRegions}
      onRegionFilter={onRegionFilterChange}
      onRemoveRegionFilter={onRemoveRegionFilter}
      onClearAllFilters={onClearAllFilters}
    />
  );
};

MemberDirectoryTab.propTypes = {
  filteredMembers: array.isRequired,
  membersLoading: bool.isRequired,
  membersError: string,
  selectedRegions: array.isRequired,
  availableRegions: array.isRequired,
  onSearchChange: func.isRequired,
  onRegionFilterChange: func.isRequired,
  onRetry: func.isRequired,
  onRemoveRegionFilter: func.isRequired,
  onClearAllFilters: func.isRequired
};